import { TitleProps } from './Types'
import Styles from './Title.module.scss'

const Title = ({ children }: TitleProps) => {
  return <div className={Styles.title}>{children}</div>
}

export { Title }
